var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.groupOpen)?_c('div',[_c('v-icon',[_vm._v("expand_more")])],1):_vm._e(),(_vm.groupOpen)?_c('div',[_c('v-icon',[_vm._v("expand_less")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }